import styled from '@emotion/styled';
import Button from '@/components/comm/Button';
import Divider from '@/components/comm/Divider';
import Modal from '@/components/comm/Modal';
import { breakpointSmall } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';

type ActivateUserModalProps = {
  showState: StateType<boolean>,
  onConfirm: () => void,
};

const Container = styled.div`
display: flex;
min-width: 400px;
flex-direction: column;
align-self: center;
background-color: ${colors.white};
border-radius: 8px;
@media (max-width: ${breakpointSmall}) {
  min-width: 0;
  max-width: calc(100vw - 40px);
  max-height: calc(100vh - 40px);
}
`;

const Head = styled.div`
margin: 20px 28px;
color: ${colors.textPrimary};
font-size: 18px;
font-weight: 700;
`;

const Content = styled.div`
margin: 20px 28px;
color: ${colors.black800};
font-size: 16px;
word-break: keep-all;
`;

const Bottom = styled.div`
display: flex;
justify-content: flex-end;
margin-top: 10px;
margin-right: 28px;
margin-bottom: 20px;
column-gap: 8px;
`;

const ActivateUserModal = ({ showState: [show, setShow], onConfirm }: ActivateUserModalProps) => (
  <Modal show={[show, setShow]}>
    <Container>
      <Head>휴면 계정 해제</Head>
      <Divider />
      <Content>
        휴면 계정입니다.
        <br />
        프로그래머스 휴면 계정을 해제 하시겠습니까?
      </Content>
      <Bottom>
        <Button
          padding="8px 20px"
          styleType="white"
          onClick={() => setShow(false)}
        >취소
        </Button>
        <Button padding="8px 20px" onClick={onConfirm}>확인</Button>
      </Bottom>
    </Container>
  </Modal>
);

export default ActivateUserModal;
